import { memo } from 'react'

import { twMerge } from 'tailwind-merge'

import { IconCross } from '~/components'

type Props = {
  onClick: () => void
  className?: string
}

const SearchLimitAlertComponent = ({ onClick, className }: Props) => {
  return (
    <div
      className={twMerge(
        'relative flex h-[76px] w-full flex-row items-center justify-center bg-black bg-opacity-70 shadow-md',
        className,
      )}
    >
      <p className="px-4 pr-6 text-body-s text-white">
        表示可能な件数を超えているため、新着50件のみ表示しています。範囲を絞り込んで再度検索してください。
      </p>
      <div className="h-full pt-1">
        <button
          className="absolute right-1 top-1 z-10 cursor-pointer border-none bg-transparent"
          onClick={onClick}
        >
          <IconCross className="text-white" />
        </button>
      </div>
    </div>
  )
}

export const SearchLimitAlert = memo(SearchLimitAlertComponent)
